/*
 * @Description: 网站整体布局
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2019-08-26 11:36:37
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classnames from 'classnames'
// @ts-ignore
import s from './Layout.css';
import Header from '../Header';
import Feedback from '../Feedback';

// 改版的头部
import HeaderPlus from '../HeaderPlus'
import FixedNav from '../FixedNav'
import { getUser } from '../../controller';

const matchList = [
  '行业榜',
  '总榜',
  '平台榜',
  '地理榜',
  '品牌详情',
  '品牌对比',
  'So-Me指数排⾏榜'
]

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      itemData: null,
      navVisible: true,
      childrenData: '',
      level: '',
      userInfo: [],
      doGetUrl: null,
      isLogin: false,
    }

    this.hasNewItemData = this.hasNewItemData.bind(this)
    this.doChangeChildrenData = this.doChangeChildrenData.bind(this)
    this.doChangeLevel = this.doChangeLevel.bind(this)
    this.doChangeUrl = this.doChangeUrl.bind(this)
    this.doChangeLoginState = this.doChangeLoginState.bind(this)
    this.doChangeSync = this.doChangeSync.bind(this)
    this.renderNav = this.renderNav.bind(this)
    this.toggleNavPanel = this.toggleNavPanel.bind(this)
  }

  componentDidMount () {
    getUser()
      .then(res => {
        // 如果返回结果为空，可能是未登录（拦截器返回为空），或者是404及500等后台错误， 如果返回结果有err_code则根据返回属性判断
        if (!res || res.err_code == 'need_login' || res.err_code == 404) {
          return localStorage.setItem('isLogin', 'false')
        }

        localStorage.setItem('isLogin', 'true')
        this.setState({
          userInfo: res
        })
      })
  }

  /**
   * 切换导航选中
   * @param {Number} level 
   */
  doChangeLevel (level) {
    this.setState({ level: level })
  }

  /**
   * 切换左侧导航列表类目
   * @param {Array} list 
   */
  hasNewItemData (list) {
    // console.log(ss,'layout do')
    this.setState({ itemData: list })
  }

  doChangeChildrenData (data) {
    this.setState({ childrenData: data })
  }

  doChangeUrl = (url) => {
    this.setState({ doGetUrl: url })
  }

  doChangeLoginState (login, user) {
    this.setState({
      isLogin: !!login,
      userInfo: user || {}
    })
  }

  // 组合渲染
  doChangeSync = (data, level) => {
    // console.log(data,level)
    this.setState({
      childrenData: data,
      level: level
    })
  }

  toggleNavPanel () {
    this.setState({
      navVisible: !this.state.navVisible
    })
  }

  /**
   * 左侧导航
   */
  renderNav () {
    const { navVisible, childrenData, userInfo, itemData } = this.state
    const title = this.props.children.props.title

    return (
      <div className={classnames(s.navWrpper, {
        [s.navFadeOut]: !navVisible
      })}>

        <FixedNav
          user={userInfo}
          doChangeLevel={this.doChangeLevel}
          item={title}
          brandInfo={itemData}
          doChangeRank={this.doChangeChildrenData}
          doChangeUrl={this.doChangeUrl}
          doChangeLoginState={this.doChangeLoginState}
          childrenData={childrenData}
          doChangeSync={this.doChangeSync}
        />

        <a className={s.toggleBtn} title={navVisible ? '关闭左侧导航' : '打开左侧导航'}
          onClick={this.toggleNavPanel}
        >{navVisible ? '<<' : '>>'}</a>
      </div>
    )
  }

  render() {
    const {path, children} = this.props
    // 获取组件页面名称
    const title = children.props.title
    const { navVisible, childrenData, level, userInfo, doGetUrl } = this.state

    const isPlus = matchList.indexOf(title) >= 0

    const childrenWithProps = isPlus ? React.Children.map(this.props.children, child => {
      // @ts-ignore
      return React.cloneElement(child, {
        doNewItem: this.hasNewItemData,
        childrenData: childrenData,
        treeLevel: level,
        getNewUrl: doGetUrl,
        doChangeLevel: this.doChangeLevel,
        doChangeRank: this.doChangeChildrenData,
      })
    }) : this.props.children
    
    return (
      <div>
        {isPlus ? <HeaderPlus pathname={path} /> : <Header pathname={path} user={userInfo} doChangeLoginState={this.doChangeLoginState} />}

        {/* 左侧导航栏 */}
        {isPlus && this.renderNav()}

        {/* 主体内容区域 */}
        <div className={classnames(s.mainWrapper, {
          [s.mainWrapperMargin]: isPlus && navVisible
        })}>
          {childrenWithProps}

          <Feedback />
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Layout);



// WEBPACK FOOTER //
// src/components/Layout/Layout.js